import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { NavigationsService } from '../navigations.service';

@Component({
  template: '',
  selector: 'evc-fake-leftbar',
  styleUrl: './fake-leftbar.scss',
  host: {
    '[attr.aria-hidden]': '!isOpen()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FakeLeftbarComponent {
  #navigationsService = inject(NavigationsService);
  readonly isOpen = this.#navigationsService.isLeftbarOpen.bind(this.#navigationsService);
}
